import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const EssentialWorkspaceRouteLazy = lazyWithRetry(() => import('./workspace'));
export function EssentialWorkspaceRoute() {
  return (
    <Suspense fallback={<LazyFallback className="flex-grow-1" />}>
      <EssentialWorkspaceRouteLazy />
    </Suspense>
  );
}
